export default __webpack_public_path__ + "static/Episode1-525eac662ad2c82466fb7b463c47a070.mp3";